import ControlViewModel from '@/ViewModels/ControlViewModel';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import ComponentManager from '@/Management/ComponentManager';
/**
* Das ViewModel für die AssociationLink
*/
export default class AssociationLinkViewModel extends ControlViewModel {

    /**
     * Die ViewModels für die Links
     */
    public values: KnockoutObservableArray<LinkViewModel>;

    /**
     * @param {object} params - Ein Objekt mit Optionen für das Control
     */
    constructor(params: any) {
        super(params);
        this.values = this.observableOrDefault(params.values, []) as KnockoutObservableArray<LinkViewModel>;
    }
}

ComponentManager.setViewModel('AssociationLinkViewModel', AssociationLinkViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');